define('blog',['jquery', 'core', 'site'], function ($, core, site) {
    var module = {},
        browserSupportsHistoryStateFunctions = !!(window.history && window.history.replaceState);

    module.onBlogFilterAction = function (context) {
        function submitGallery(options) {
            options = options || {};
            var originalForm = $('.js-blog-form');
            var form = originalForm;

            if (form.length) {
                if (browserSupportsHistoryStateFunctions) {
                    form = form.clone();
                }

                //Page number
                var formPageNumber = form.find('.js-blog-page-number');
                if (formPageNumber.val() == formPageNumber.data('default-value') || options.ResetPageNumber) {
                    formPageNumber.remove();
                }

                //Page size
                var formPageSize = form.find('.js-blog-page-size');
                if (formPageSize.val() == formPageSize.data('default-value')) {
                    formPageSize.remove();
                }

                //Year
                var formSelectedYear = form.find('.js-blog-selected-year');
                if (formSelectedYear.val() == formSelectedYear.data('default-value')) {
                    formSelectedYear.remove();
                }

                //Month
                var formSelectedMonth = form.find('.js-blog-selected-month');
                if (formSelectedMonth.val() == formSelectedMonth.data('default-value')) {
                    formSelectedMonth.remove();
                }

                //Tag
                var formTag = form.find('.js-blog-tag');
                if (!formTag.val()) {
                    formTag.remove();
                }

                if (options.ResetAll) {
                    if (browserSupportsHistoryStateFunctions) {
                        var originalFormPageNumberInput = originalForm.find('.js-product-gallery-page-number');
                        var originalFormPageSizeInput = originalForm.find('.js-product-gallery-page-size');

                        originalFormPageNumberInput.val(originalFormPageNumberInput.data('default-value'));
                        originalFormPageSizeInput.val(originalFormPageSizeInput.data('default-value'));

                        originalForm.find('.js-product-gallery-other-keywords').remove();
                    }

                    form.find('input').remove();
                }
                if (browserSupportsHistoryStateFunctions) {
                    core.dom.doAction(form, function () {
                        var query = form.serialize();
                        var url = form.data('browser-url') + (query.length ? '?' + query : '');
                        window.history.replaceState(undefined, '', url);

                        if (!core.ui.isElementInViewport($('.js-blog-scroll-to'), true)) {
                            core.ui.scrollTo('.js-blog-scroll-to');
                        }
                    });
                } else {
                    core.ui.lock('screen');
                    form.submit();
                }
            }
        }

        context.andFind('.js-blog-clear-filter').click(function (e) {
            e.preventDefault();
            submitGallery({ ResetAll: true });
        });


        context.andFind('.js-blog-filter-by-tag').click(function (e) {
            e.preventDefault();

            var formSelectedMonth = $('.js-blog-selected-month');
            formSelectedMonth.val(formSelectedMonth.data('default-value'));

            var formSelectedYear = $('.js-blog-selected-year');
            formSelectedYear.val(formSelectedYear.data('default-value'));

            var tag = $(this).data('tag');
            $('.js-blog-tag').val(tag);

            submitGallery({ ResetPageNumber: true });
        });

        context.andFind('.js-blog-filter-by-year-month').click(function (e) {
            e.preventDefault();

            $('.js-blog-tag').val('');

            var year = $(this).data('year');
            $('.js-blog-selected-year').val(year);

            var month = $(this).data('month');
            $('.js-blog-selected-month').val(month);

            submitGallery({ ResetPageNumber: true });
        });

        context.andFind('.js-page-li').click(function (e) {
            e.preventDefault();

            var $this = $(this);
            if ($this.hasClass('disabled')) {
                return;
            }

            var formPageNumber = $('.js-blog-page-number');
            var currentPageNumber = parseInt(formPageNumber.val());

            if ($this.hasClass('PagedList-skipToPrevious')) {
                formPageNumber.val(currentPageNumber - 1);
            } else if ($this.hasClass('PagedList-skipToNext')) {
                formPageNumber.val(currentPageNumber + 1);
            } else {
                var clickedPageNumber = $this.find('a').text();
                formPageNumber.val(clickedPageNumber);
            }

            submitGallery();
        });
    };

    // Initialize
    $(document).ready(function () {
        core.scopes.addHandler('*', function (context) {
            module.onBlogFilterAction(context);
        });
    });

    return module;
});
